import { useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify'; // V5
// import { generateClient } from 'aws-amplify/api'; // V6
import GlobalStateStore from '@/context/store/global-state';
import BalanceSubscription from '@/services/graphql/subscriptions/balance';
import CountLogin from '@/services/graphql/subscriptions/count-login';
import TransactionQueries from '../services/graphql/queries/transaction';
import useBrandConfigStore from '@/context/store/useBrandConfigStore.store';
import localStorageUtils from '@/utils/localStorage.utils';
import useUser from '@/features/user/userInfo/useUser';
import useAuth from '../src/features/auth/useAuth';
import { toast } from 'react-toastify';
// import { useQuery, gql } from '@apollo/client';
// import gql from 'graphql-tag';
// import useAuthStore from '../src/features/auth/useAuthStore';
// import { toast } from 'react-toastify';
// import apolloClient from '../services/ApolloClient';

// const client = generateClient();

// const useAppSyncSubscription = ({
// 	query,
// 	variables,
// 	authToken,
// 	callback,
// 	dependencies = [],
// 	shouldSubscribe = () => true // Default to always true if not provided
// }) => {
// 	useEffect(() => {
// 		let subscription;

// 		if (shouldSubscribe()) {
// 			subscription = client
// 				.graphql({
// 					query: query,
// 					variables: variables,
// 					authToken: authToken
// 				})
// 				.subscribe({
// 					next: ({ data }) => {
// 						// console.log('beneran ini kan : ', data);
// 						if (callback) callback(data);
// 					},
// 					error: (error) => console.warn(error)
// 				});
// 			// subscription = API.graphql(graphqlOperation(query, variables, authToken)).subscribe({
// 			// 	next: ({ value }) => {
// 			// 		console.log('value subs : ', value);
// 			// 		if (callback) callback(value);
// 			// 	}
// 			// });
// 		}

// 		// Cleanup on unmount
// 		return () => {
// 			if (subscription) subscription.unsubscribe();
// 		};
// 	}, dependencies);
// };

// const useAppSyncMutation = ({
// 	query,
// 	variables,
// 	authToken,
// 	callback,
// 	dependencies = [],
// 	shouldMutate = () => true // Default to always true if not provided
// }) => {
// 	useEffect(() => {
// 		console.log('shouldMutate : ', shouldMutate);
// 		console.log('authToken : ', authToken);
// 		if (shouldMutate()) {
// 			// let mutation;
// 			console.log('masuk gk sih : ', shouldMutate());
// 			client
// 				.graphql({
// 					query: query,
// 					variables: variables,
// 					authToken: authToken
// 				})
// 				.then((res) => {
// 					console.log('Mutation res :', res);
// 					if (callback) callback(res);
// 				});
// 			// API.graphql(graphqlOperation(mutation, variables, authToken))
// 			// 	.then((response) => {
// 			// 		console.log('Mutation response:', response);
// 			// 		if (callback) callback(response);
// 			// 	})
// 			// 	.catch((error) => {
// 			// 		console.error('Mutation error:', error);
// 			// 	});
// 		}

// 		// Cleanup on unmount
// 		return () => {
// 			// if(mutation)
// 			// You might want to add cleanup logic here if needed
// 		};
// 	}, dependencies);
// };

const useAppSyncSubscriptionOld = ({
	query,
	variables,
	authToken,
	callback,
	dependencies = [],
	shouldSubscribe = () => true // Default to always true if not provided
}) => {
	useEffect(() => {
		let subscription;

		if (shouldSubscribe()) {
			subscription = API.graphql(graphqlOperation(query, variables, authToken)).subscribe({
				next: ({ value }) => {
					if (callback) callback(value);
				}
			});
		}

		// Cleanup on unmount
		return () => {
			if (subscription) subscription.unsubscribe();
		};
	}, dependencies);
};

const useAppSyncMutationOld = ({
	query,
	variables,
	authToken,
	callback,
	dependencies = [],
	shouldMutate = () => true // Default to always true if not provided
}) => {
	useEffect(() => {
		// console.log('shouldMutate : ', shouldMutate);
		// console.log('authToken : ', authToken);
		if (shouldMutate()) {
			// let mutation;
			API.graphql(graphqlOperation(query, variables, authToken))
				.then((response) => {
					// console.log('Mutation response:', response);
					if (callback) callback(response);
				})
				.catch((error) => {
					console.error('Mut error:', error);
				});
		}

		// Cleanup on unmount
		return () => {
			// if(mutation)
			// You might want to add cleanup logic here if needed
		};
	}, dependencies);
};

//

// export const useAppsyncSubscriptionWalletBalanceHook = () => {
// 	const { user, token, isAuthenticated, setUpdateWalletBalance } = GlobalStateStore((state) => ({
// 		user: state.user,
// 		token: state.token,
// 		isAuthenticated: state.isAuthenticated,
// 		setUpdateWalletBalance: state.setUpdateWalletBalance
// 	}));

// 	useAppSyncSubscription({
// 		query: BalanceSubscription.SubscribeBalance,
// 		variables: { brandUsername: String(user?.brandUsername) },
// 		authToken: token,
// 		callback: (value) => {
// 			const valueParse = value?.newBalance;

// 			const newWalletBalance = JSON.parse(valueParse?.walletBalance);
// 			setUpdateWalletBalance({
// 				newWalletBalance: newWalletBalance
// 			});
// 		},
// 		dependencies: [isAuthenticated, token, user],
// 		shouldSubscribe: () => isAuthenticated && token && user // Your custom condition
// 	});

// 	return {};
// };

// export const useAppsyncCountLoginHook = () => {
// 	const { user, token, isAuthenticated } = GlobalStateStore((state) => ({
// 		user: state.user,
// 		token: state.token,
// 		isAuthenticated: state.isAuthenticated
// 	}));

// 	useAppSyncMutation({
// 		query: CountLogin.mutationLogin,
// 		authToken: token,
// 		dependencies: [isAuthenticated, token, user],
// 		shouldMutate: () => isAuthenticated && token && user
// 	});

// 	return {};
// };

export const useAppsyncSubscriptionWalletBalanceHook = () => {
	const token = localStorageUtils.getLoginToken();
	const { user } = useUser();
	const { setUpdateWalletBalance } = GlobalStateStore((state) => ({
		setUpdateWalletBalance: state.setUpdateWalletBalance
	}));

	useAppSyncSubscriptionOld({
		query: BalanceSubscription.SubscribeBalance,
		variables: { brandUsername: String(user?.brandUsername) },
		authToken: token,
		callback: (value) => {
			const valueParse = value?.data?.newBalance;

			console.log('valueParse : ', valueParse);

			const newWalletBalance = JSON.parse(valueParse?.walletBalance);
			setUpdateWalletBalance({
				newWalletBalance: newWalletBalance
			});
		},
		dependencies: [token, user],
		shouldSubscribe: () => token && user // Your custom condition
	});

	return {};
};

export const useAppsyncCountLoginHook = () => {
	const { loginToken, isLoggedIn } = useAuth();

	useAppSyncMutationOld({
		query: CountLogin.mutationLogin,
		authToken: loginToken,
		dependencies: [loginToken, isLoggedIn],
		shouldMutate: () => loginToken && loginToken !== '' && isLoggedIn
	});

	return {};
};

export const useAppsyncGetDepoWdTransaction = ({ setDepoWdData }) => {
	const { brandId } = useBrandConfigStore((state) => ({ brandId: state.brandId }));

	useAppSyncMutationOld({
		query: TransactionQueries.GetDepoWd,
		authToken: process.env.NEXT_PUBLIC_AWS_APPSYNC_APIKEY,
		variables: { brandId: brandId },
		callback: (value) => {
			setDepoWdData([...(value?.data?.getDepoWd?.report ?? [])]);
		},
		dependencies: [brandId],
		shouldMutate: () => brandId
	});

	return {};
};

// export const useAppsyncGetDepoWdTransaction = ({ setDepoWdData }) => {
// 	const { brandId } = useBrandConfigStore((state) => ({ brandId: state.brandId }));
// 	useAppSyncMutation({
// 		query: TransactionQueries.GetDepoWd,
// 		authToken: process.env.NEXT_PUBLIC_AWS_APPSYNC_APIKEY,
// 		variables: { brandId: brandId },
// 		callback: (value) => {
// 			setDepoWdData([...(value?.data?.getDepoWd?.report ?? [])]);
// 		},
// 		dependencies: [brandId],
// 		shouldMutate: () => brandId
// 	});
// 	return {};
// };

// const GET_DEPO_WD_QUERY = gql`
// 	query getDepoWd($brandId: String!) {
// 		getDepoWd(brandId: $brandId) {
// 			report {
// 				amount
// 				currency
// 				currencyLogo
// 				username
// 				transactionType
// 			}
// 		}
// 	}
// `;

// export const useAppsyncGetDepoWdTransaction = ({ setDepoWdData }) => {
// 	const { brandId } = useBrandConfigStore((state) => ({ brandId: state.brandId }));

// 	// Apollo useQuery hook
// 	const { loading, error } = useQuery(GET_DEPO_WD_QUERY, {
// 		variables: { brandId },
// 		skip: !brandId, // Skip the query if brandId is not available
// 		onCompleted: (data) => {
// 			setDepoWdData(data?.getDepoWd?.report ?? []);
// 		}
// 	});

// 	// Optional: Handle loading and error states
// 	if (loading) return 'Loading...';
// 	if (error) return `Error! ${error.message}`;

// 	return {};
// };

export const useAppsyncSubscriptionDepowd = () => {
	const token = localStorageUtils.getLoginToken();
	const { user } = useUser();

	useAppSyncSubscriptionOld({
		query: BalanceSubscription.SubscribeDepo,
		authToken: token,
		variables: { brandUsername: token?.split(':')[0] },
		callback: (value) => {
			const response = value.data.playerNotifDepoWd;
			toast.info(
				`Your ${response?.transactionType.toLowerCase()} has been ${
					response?.transactionStatus.toLowerCase() === 'success' ? 'approved' : 'declined'
				}`
			);
		},
		dependencies: [token, user],
		shouldMutate: () => token && user
	});

	return {};
};

// const notifSub = API.graphql(
// 	graphqlOperation(
// 		BalanceSubscription.SubscribeDepo,
// 		{ brandUsername: token?.split(':')[0] },
// 		token
// 	)
// ).subscribe({
// 	next: ({ value }) => {
// 		const response = value.data.playerNotifDepoWd;
// 		toast(
// 			toastStatus.INFO,
// 			`Your ${response.transactionType.toLowerCase()} has been ${
// 				response.transactionStatus.toLowerCase() === 'success' ? 'approved' : 'declined'
// 			}`
// 		);
// 	}
// });
